import type { LeagueMode } from "../pages/createLeague/modeContent";

interface Props {
  mode: LeagueMode;
  size?: number;
  strokeWidth?: number;
  color?: string;
}

/** Single source of truth for the game-mode glyph. Used at 26px (create-league picker,
 * how-to-play modal, landing page, gw-recap header) and at 13px via `ModeIconSmall`
 * (LeaguePage and every per-mode page's compact header badge) — one geometry,
 * size-parameterised, instead of two independently hand-maintained SVG sets. */
export default function ModeIcon({ mode, size = 26, strokeWidth = 1.8, color }: Props) {
  const svgProps = { width: size, height: size, viewBox: "0 0 28 28", fill: "none" as const, stroke: color ?? "currentColor", strokeWidth };
  switch (mode) {
    case "TARGET":
      return (
        <svg {...svgProps}>
          <circle cx={14} cy={14} r={11} />
          <circle cx={14} cy={14} r={6} />
          <circle cx={14} cy={14} r={2} fill={color ?? "currentColor"} stroke="none" />
          <path d="M20 8l2-2M22 6l-2 2" strokeWidth={strokeWidth * 0.85} strokeLinecap="round" />
        </svg>
      );
    case "GAMEWEEK_CHALLENGE":
      return (
        <svg {...svgProps}>
          <path d="M14 3l2.5 7.5H24l-6.5 4.5 2.5 7.5L14 18l-6 4.5 2.5-7.5L4 10.5h7.5L14 3z" strokeLinejoin="round" />
        </svg>
      );
    case "FINAL_POSITIONS":
      return (
        <svg {...svgProps}>
          <rect x={4} y={16} width={5} height={9} rx={1} />
          <rect x={11.5} y={10} width={5} height={15} rx={1} />
          <rect x={19} y={4} width={5} height={21} rx={1} />
        </svg>
      );
    case "SCORE_PREDICTOR":
      return (
        <svg {...svgProps}>
          <rect x={4} y={4} width={9} height={9} rx={1} />
          <rect x={15} y={4} width={9} height={9} rx={1} />
          <rect x={4} y={15} width={9} height={9} rx={1} />
          <rect x={15} y={15} width={9} height={9} rx={1} />
        </svg>
      );
    case "SYNDICATE":
      return (
        <svg {...svgProps}>
          <circle cx={9} cy={9} r={4} />
          <circle cx={20} cy={9} r={4} />
          <path d="M4.5 24c0-4 2-7 4.5-7s4.5 3 4.5 7" strokeLinecap="round" />
          <path d="M15.5 24c0-4 2-7 4.5-7s4.5 3 4.5 7" strokeLinecap="round" />
        </svg>
      );
  }
}
